import {useEffect, useMemo, useState} from 'react';

import {constructOptions, VisibilityOptions} from 'settings/visibility-options/VisibilityOptions';
import * as vo from 'settings/visibility-options/VisibilityOptions';

export interface DisplayOptionsState {
  displayOptions: VisibilityOptions | undefined;
  showFormulas: boolean;
  highlightCustomColumns: boolean;
}

export default function useDisplayOptionsState(useDisplayOptions: boolean): DisplayOptionsState {
  const displayOptions = useMemo(
    () =>
      constructOptions('note', [
        {base: vo.ELN_SHOW_FORMULAS, visible: false, editable: true, sync: true},
        {base: vo.ELN_HIGHLIGHT_CUSTOM_COLUMNS, visible: false, editable: true, sync: true},
      ]),
    []
  );

  const [showFormulas, setShowFormulas] = useState(false);
  const [highlightCustomColumns, setHighlightCustomColumns] = useState(false);

  useEffect(() => {
    const updateState = (): void => {
      setShowFormulas(displayOptions.getOption(vo.ELN_SHOW_FORMULAS.name)?.get('visible') ?? false);
      setHighlightCustomColumns(
        displayOptions.getOption(vo.ELN_HIGHLIGHT_CUSTOM_COLUMNS.name)?.get('visible') ?? false
      );
    };

    displayOptions.on('redraw', updateState);
    updateState();

    return () => displayOptions.off('redraw', updateState);
  }, [displayOptions]);

  if (!useDisplayOptions) {
    return {displayOptions: undefined, showFormulas: false, highlightCustomColumns: false};
  }

  return {displayOptions, showFormulas, highlightCustomColumns};
}
